<template>
	<button :disabled="disable"
			class="btn text-error-600 transition-all
				hover:preset-filled-error-500
				focus:preset-filled-error-500
				active:bg-error-900
				disabled:bg-error-950 disabled:text-opacity-50 disabled:brightness-75 py-5" :class="`${size} ${borderStyle}`">
		<slot/>
	</button>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';

export default defineComponent({
	name: 'BasicButtonError',
	props: {
		disable: {
			type: Boolean,
			default: false,
		},
    size: {
      type: String as PropType<'btn-md' | 'btn-lg' | 'btn-base' | 'btn-sm'>,
      default: 'btn-md',
    },
    border: {
      type: Boolean,
      default: false,
    }
	},
  computed: {
    borderStyle(): string {
      return this.$props.border ? 'preset-outlined-surface-500 hover:preset-outlined-error-500' : '';
    }
  }
});
</script>

<style scoped>

</style>
